
// Generated with baseline-styles - Do not modify.
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.styles = {
    "resize-box": "resize-box-89c168a1",
    "transitional": "transitional-89c168a1",
    "resizeBox": "resize-box-89c168a1"
};
exports.styleSource = ".resize-box-89c168a1{position:relative;box-sizing:border-box;overflow:hidden;transition:all .2s ease}.transitional-89c168a1>div{box-sizing:content-box;height:fit-content;padding:1px}";
exports.default = exports.styles;
            
module.moduleType = "style";
